import { MarkerClusterer } from "@googlemaps/markerclusterer";

common.View.create('map::canvas.blocks.modules.map.Block', {

    map: null,
    markers: [],
    activeMarker: null,
    lastInfoWindow: null,

    iconNormal: '/img/website/mapIcon.svg',
    iconHover: '/img/website/mapIconHover.svg',

    onDOMLoad() {
        // If cookies are acceptd with window.dispatchEvent(new CustomEvent('cookies-accepted'));
        window.addEventListener('cookies-accepted', () => {
            this.init();
        });

        this.init();
    },

    init() {
        if( this.getCookie('marketing') ) {
            this.element.find('#map').removeClass('hidden');
            this.element.find('.no-cookies').addClass('hidden');

            this.initMap();
        } else {
            this.element.find('#map').addClass('hidden');
            this.element.find('.no-cookies').removeClass('hidden');
        }
    },

    getCookies()
    {
        var pairs = document.cookie.split(";");
        var cookies = {};
        for (var i=0; i<pairs.length; i++){
            var pair = pairs[i].split("=");
            cookies[(pair[0]+'').trim()] = unescape(pair.slice(1).join('='));
        }
        return cookies;
    },

    getCookie(name) {
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); 
        return match ? match[1] : null;
    },

    initMap()
    {
        let apiKey = this.element.find('.apiKey').text();

        // Check when script is done loading
        $.getScript('https://maps.googleapis.com/maps/api/js?key='+ apiKey +'&libraries=places&callback=map.canvas.blocks.modules.map.Block', () => {
            this.setupMap();
            this.setupMarkers();

            this.element.find('.filters').find('input, select, textarea')
                .on('change', (e) => {
                    this.filterMarkers();
                });

            this.element.find('.removeFilters')
                .on('click', (e) => {
                    this.filterMarkers();
                })

        });
    },

    filterMarkers()
    {
        let $fields = this.element.find('.filters').find('input, select, textarea');
        let $map = this.element.find('#map');
        let locations = JSON.parse($map.attr('data-locations'));

        // Filter locations based on filters
        let filteredLocations = locations.filter((location) => {
            let filter = true;

            $fields.each((index, field) => {
                let $field = $(field);
                let value = $field.val();
                let fieldId = $field.attr('id');
                let locationValue = location[fieldId] || '';

                if (value != '' && value != 'all') {
                    if (locationValue.toLowerCase().indexOf(value.toLowerCase()) == -1) {
                        filter = false;
                    }
                }
            });

            return filter;
        });

        //this.setupMap();
        this.setupMarkers(filteredLocations);
        this.clusterMarkers(this.markers);
    },

    setupMap()
    {
        // Map options
        var options = {
            zoom: 8,
            center: new google.maps.LatLng(51.8920229, 5.1867626),
            styles: this.mapStyling(),
            disableDefaultUI: false,
        };

        // New map
        let $map = this.element.find('#map');
        this.map = new google.maps.Map($map.get(0), options);
    },

    setupMarkers(locations = null)
    {
        let $map = this.element.find('#map');
        
        if( !locations ) {
            locations = JSON.parse($map.attr('data-locations'));
        }

        this.markers = [];

        // Loop through locations and add marker
        locations.forEach((location) => {
            this.markers.push(this.addMarker(location, {
                coords: {lat: parseFloat(location.location.lat), lng: parseFloat(location.location.lng)}
            }));
        });

        // Add a marker clusterer to manage the markers.
        this.clusterMarkers(this.markers);

        // Center map on markers
        this.centerMapOnMarkers();
    },

    centerMapOnMarkers()
    {
        let bounds = new google.maps.LatLngBounds();

        this.markers.forEach((marker) => {
            bounds.extend(marker.getPosition());
        });

        this.map.fitBounds(bounds);

        // Set max zoom, which is not changed by user zooming
        google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
            if (this.map.getZoom() > 15) {
                this.map.setZoom(15);
            }
        });

    },

    customClusterMarkRenderer()
    {
        // Define a custom renderer
        const customRenderer = {
            render: ({ count, position }, stats) => {
                // Create a new div to represent the cluster
                const div = document.createElement('div');

                // Style the div
                div.style.backgroundColor = '#DA740F'; // Set the background color
                div.style.color = 'white'; // Set text color
                div.style.textAlign = 'center';
                div.style.borderRadius = '50%';
                div.style.width = '30px';
                div.style.height = '30px';
                div.style.lineHeight = '30px'; // To center the text vertically
                div.innerHTML = count;

                // create svg url with fill color
                const svg = window.btoa(`
                <svg fill="#DA740F" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <circle cx="120" cy="120" r="120" />    
                </svg>`);

                // Calculate the anchor point
                const anchorPoint = new google.maps.Point(25, 50); // Adjust these values as needed

                return new google.maps.Marker({
                    position,
                    icon: {
                        url: `data:image/svg+xml;base64,${svg}`,
                        scaledSize: new google.maps.Size(50, 50),
                        anchor: anchorPoint, // Set the anchor point here
                    },
                    label: {
                        text: String(count),
                        color: "rgba(255,255,255,0.9)",
                        fontSize: "20px",
                    },
                    // adjust zIndex to be above other markers
                    //zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });;
            },
        };

         return customRenderer; 
    },
    
    clusterMarkers(markers)
    {
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }
        
        // Add a marker clusterer to manage the markers.
        this.markerCluster = new MarkerClusterer({
            map: this.map,
            markers: markers,
            renderer: this.customClusterMarkRenderer(),
            onClusterClick: (event, cluster, map) => {
                this.map.fitBounds(cluster.bounds);

                // Calculate new zoom level based on bounds
                const bounds = cluster.bounds;
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();
                const latDiff = ne.lat() - sw.lat();
                const lngDiff = ne.lng() - sw.lng();
                const maxZoom = this.map.maxZoom || 21;
                const minZoom = this.map.minZoom || 0;
                const latZoom = latDiff < 0 ? minZoom : Math.min(Math.floor(Math.log(Math.abs(360 / latDiff)) / Math.LN2), maxZoom);
                const lngZoom = lngDiff < 0 ? minZoom : Math.min(Math.floor(Math.log(Math.abs(360 / lngDiff)) / Math.LN2), maxZoom);
                const newZoom = Math.min(Math.min(latZoom, lngZoom), maxZoom);

                // Zoom in on the cluster.
                this.map.setZoom(newZoom);
            }
        });

        // Adjusted clusterclick listener
        this.markerCluster.addListener('clusterclick', (cluster) => {
            // Calculate the new zoom level, but don't exceed a maximum zoom level
            let newZoom = Math.min(this.map.getZoom() + 2, 15); // Adjust '15' to your maximum desired zoom level
    
            // Zoom in on the cluster.
            this.map.setZoom(newZoom);
            this.map.panTo(cluster.getCenter());

            console.log(cluster);
        });
    },

    mapStyling() {
        return [
            { 
                "featureType": "all", 
                "elementType": "labels.text.fill", 
                "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] 
            }, 
            { 
                "featureType": "all", 
                "elementType": "labels.text.stroke", 
                "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] 
            }, 
            { 
                "featureType": "all", 
                "elementType": "labels.icon", 
                "stylers": [{ "visibility": "off" }] 
            }, 
            { 
                "featureType": "administrative", 
                "elementType": "geometry.fill", 
                "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] 
            }, 
            { 
                "featureType": "administrative", 
                "elementType": "geometry.stroke", 
                "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] 
            }, 
            { 
                "featureType": "administrative.country", 
                "elementType": "geometry.stroke", 
                "stylers": [{ "visibility": "on" }, { "color": "#dddddd" }] 
            }, 
            { 
                "featureType": "administrative.province", 
                "elementType": "labels.text", 
                "stylers": [{ "visibility": "off" }, { "color": "#2b2b2b" }] 
            }, 
            { 
                "featureType": "administrative.locality", 
                "elementType": "labels.text.fill", 
                "stylers": [{ "visibility": "on" }, { "color": "#a3a3a3" }] // Change color of city names
            }, 
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text.fill",
                "stylers": [
                    { "color": "#a3a3a3"}, { "visibility": "on" }
                ]
            },
            { 
                "featureType": "landscape", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] 
            }, 
            { 
                "featureType": "landscape.natural.landcover", 
                "elementType": "labels.text", 
                "stylers": [{ "visibility": "off" }] 
            }, 
            { 
                "featureType": "landscape.natural.terrain", 
                "elementType": "labels.text", 
                "stylers": [{ "visibility": "off" }] 
            }, 
            { 
                "featureType": "poi", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] 
            }, 
            { 
                "featureType": "poi.park", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] 
            }, 
            { 
                "featureType": "road.highway", 
                "elementType": "geometry.fill", 
                "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] 
            }, 
            { 
                "featureType": "road.highway", 
                "elementType": "geometry.stroke", 
                "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] 
            }, 
            { 
                "featureType": "road.arterial", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] 
            }, 
            { 
                "featureType": "road.local", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] 
            }, 
            { 
                "featureType": "transit", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] 
            }, 
            { 
                "featureType": "water", 
                "elementType": "geometry", 
                "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] 
            }, 
            { 
                "featureType": "water", 
                "elementType": "labels.text", 
                "stylers": [{ "visibility": "off" }] 
            }
        ];
    },

    addMarker(location, props)
    {
        let marker = new google.maps.Marker({
            position: props.coords,
            map: this.map,
            icon: this.iconNormal,
        });

        // On mouseover, change icon
        marker.addListener('mouseover', () => {
            marker.setIcon(this.iconHover);
        });

        // On mouseout, change icon
        marker.addListener('mouseout', () => {
            if( this.activeMarker != marker ) {
                marker.setIcon(this.iconNormal);
            }
        });

        // Info Window Content
        var contentString = `
            <div class="sm:min-w-[230px] px-2 max-w-md font-montserrat">
                ` + (location.image ? `
                    <img src="` + location.image + `" class="w-full h-16 object-left object-contain" alt="` + location.title + `">
                ` : '') + `
                <div class="bg-white py-2">
                    <h2 class="text-lg font-semibold mb-2 border-b pb-2">`+ location.title + `</h2>
                    <div class="text-sm mb-4">` + location.description + `</div>
                    <a href="tel:` + location.phone + `" class="block btn-blue-outline mb-2 text-center text-sm !py-3.5 w-full"><i class="fal fa-phone mr-2"></i> ` + location.phone + `</a>
                    <a target="_blank" href="` + location.url + `" class="block btn-orange text-center text-sm !py-3.5 w-full">Meer informatie</a>
                </div>
            </div>`; 

        // Add Info Window
        let infowindow = new google.maps.InfoWindow({
            content: contentString,
            disableAutoPan: true
        });

        // Add Listener
        marker.addListener("click", () => {
            // Close last info window
            infowindow.open(this.map, marker);
            if( this.lastInfoWindow && this.lastInfoWindow !== infowindow ) {
                this.lastInfoWindow.close();
            }
            this.lastInfoWindow = infowindow;

            // Show info window on screen center
            const newCenter = this.calculateOffsetCenter(marker.getPosition(), 0, -100); // Adjust these values as needed
            this.map.panTo(newCenter);

            // Change icon
            marker.setIcon(this.iconHover);

            this.activeMarker = marker;

            // Reset all other markers
            this.markers.forEach((marker) => {
                if( marker != this.activeMarker ) {
                    marker.setIcon(this.iconNormal);
                }
            });
        });

        // When closing info window, reset icon
        infowindow.addListener('closeclick', () => {
            marker.setIcon(this.iconNormal);

            this.activeMarker = null;
        });

        return marker;
    },

    calculateOffsetCenter(markerPosition, offsetx, offsety) {
        // offsetx and offsety are in pixels
        const scale = Math.pow(2, this.map.getZoom());
        const nw = new google.maps.LatLng(
            this.map.getBounds().getNorthEast().lat(),
            this.map.getBounds().getSouthWest().lng()
        );
    
        const worldCoordinateNW = this.map.getProjection().fromLatLngToPoint(nw);
        const worldCoordinate = this.map.getProjection().fromLatLngToPoint(markerPosition);
    
        const adjustedLatLng = new google.maps.Point(
            (worldCoordinate.x - offsetx / scale) || 0,
            (worldCoordinate.y + offsety / scale) || 0
        );
    
        return this.map.getProjection().fromPointToLatLng(adjustedLatLng);
    }
    

});